import React from 'react';
import Icon from '../AppIcon';

const CaseProgressIndicator = ({ currentStep = 1, totalSteps = 4 }) => {
  const steps = [
    { number: 1, label: 'Case Details', icon: 'FileText' },
    { number: 2, label: 'Upload Evidence', icon: 'Upload' },
    { number: 3, label: 'Review', icon: 'CheckCircle' },
    { number: 4, label: 'Submit', icon: 'Send' },
  ];

  const getStepStatus = (stepNumber) => {
    if (stepNumber < currentStep) return 'completed';
    if (stepNumber === currentStep) return 'active';
    return 'pending';
  };

  return (
    <div className="w-full py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="progress-indicator">
          {steps?.map((step, index) => (
            <React.Fragment key={step?.number}>
              <div className="flex flex-col items-center gap-2">
                <div
                  className={`progress-step ${getStepStatus(step?.number)}`}
                  role="status"
                  aria-label={`Step ${step?.number}: ${step?.label}`}
                  aria-current={
                    step?.number === currentStep ? 'step' : undefined
                  }
                >
                  {getStepStatus(step?.number) === 'completed' ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <Icon name={step?.icon} size={20} />
                  )}
                </div>
                <span
                  className={`caption ${
                    getStepStatus(step?.number) === 'pending' ?'text-muted-foreground' :'text-foreground'
                  }`}
                >
                  {step?.label}
                </span>
              </div>
              {index < steps?.length - 1 && (
                <div
                  className={`progress-connector ${
                    step?.number < currentStep ? 'completed' : ''
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseProgressIndicator;